const normalizeCode = (value: string): string => value.trim().toUpperCase()

const LEGACY_TO_CANONICAL: Record<string, string> = {
  READ_EQUIPMENT: 'READ_MACHINERY',
  CREATE_EQUIPMENT: 'CREATE_MACHINERY',
  UPDATE_EQUIPMENT: 'UPDATE_MACHINERY',
  DELETE_EQUIPMENT: 'DELETE_MACHINERY',
  IMPORT_EQUIPMENT: 'IMPORT_MACHINERY',
  EXPORT_EQUIPMENT: 'EXPORT_MACHINERY',
  READ_COMPONENT: 'READ_MACHINERY',
  CREATE_COMPONENT: 'CREATE_MACHINERY',
  UPDATE_COMPONENT: 'UPDATE_MACHINERY',
  DELETE_COMPONENT: 'DELETE_MACHINERY',
  REQUISITION_VIEW: 'READ_REQUISITION',
  REQUISITION_CREATE: 'CREATE_REQUISITION',
  REQUISITION_EDIT: 'UPDATE_REQUISITION',
  REQUISITION_DELETE: 'DELETE_REQUISITION',
  PO_VIEW: 'READ_PURCHASE_ORDER',
  PO_CREATE: 'CREATE_PURCHASE_ORDER',
  PO_EDIT: 'UPDATE_PURCHASE_ORDER',
  UPDATE_PO: 'UPDATE_PURCHASE_ORDER',
  GRN_VIEW: 'READ_GOODS_RECEIPT',
  GRN_CREATE: 'CREATE_GOODS_RECEIPT',
  GRN_EDIT: 'UPDATE_GOODS_RECEIPT',
  DELIVERY_VIEW: 'READ_DELIVERY_TRACKING',
  DELIVERY_CREATE: 'CREATE_DELIVERY_TRACKING',
  READ_INVOICE: 'INVOICE_VIEW',
  READ_INVOICE_MGMT: 'INVOICE_VIEW',
  READ_INVOICE_VIEW: 'INVOICE_VIEW',
  READ_INVOICE_EDIT: 'INVOICE_EDIT',
  READ_DELIVERY_TRAC: 'READ_DELIVERY_TRACKING',
  READ_DELIVERY_TRACK: 'READ_DELIVERY_TRACKING',
  READ_DELIVERY_UPDATED: 'READ_DELIVERY_TRACKING',
  VIEW_QHSE_DEFECT_CLOSURE_EVIDENCE: 'READ_QHSE_DEFECT_CLOSURE_EVIDENCE',
  MANAGE_PMS_JOB_MASKING: 'CREATE_JOB_MASKING',
}

const HIDDEN_MATRIX_ALIASES = new Set<string>([
  'READ_EQUIPMENT',
  'CREATE_EQUIPMENT',
  'UPDATE_EQUIPMENT',
  'DELETE_EQUIPMENT',
  'IMPORT_EQUIPMENT',
  'EXPORT_EQUIPMENT',
  'READ_COMPONENT',
  'CREATE_COMPONENT',
  'UPDATE_COMPONENT',
  'DELETE_COMPONENT',
  'READ_PROCUREMENT_OVERVIEW',
  'PROCUREMENT_LOG_VIEW',
  'USER_PERMISSION_VIEW',
  'USER_PERMISSION_MANAGE',
  'REQUISITION_VIEW',
  'REQUISITION_CREATE',
  'REQUISITION_EDIT',
  'REQUISITION_DELETE',
  'PO_VIEW',
  'PO_CREATE',
  'PO_EDIT',
  'UPDATE_PO',
  'GRN_VIEW',
  'GRN_CREATE',
  'GRN_EDIT',
  'DELIVERY_VIEW',
  'DELIVERY_CREATE',
  'READ_INVOICE',
  'READ_INVOICE_MGMT',
  'READ_INVOICE_VIEW',
  'READ_INVOICE_EDIT',
  'READ_DELIVERY_TRAC',
  'READ_DELIVERY_TRACK',
  'READ_DELIVERY_UPDATED',
  'READ_DELIVERY_VIEW',
  'READ_LIBRARY_HEAD',
  'MANAGE_LIBRARY_HEAD',
  'READ_LIBRARY_SUBHEAD',
  'MANAGE_LIBRARY_SUBHEAD',
  'READ_LIBRARY_SUBCATEGORY',
  'MANAGE_LIBRARY_SUBCATEGORY',
  'READ_LIBRARY_ACCOUNTING',
  'MANAGE_LIBRARY_ACCOUNTING',
  'READ_LIBRARY_SUBACCOUNTING',
  'MANAGE_LIBRARY_SUBACCOUNTING',
  'READ_LIBRARY_ADDRESS',
  'MANAGE_LIBRARY_ADDRESS',
  'VIEW_VENDOR_LIBRARY',
  'MANAGE_VENDOR_LIBRARY',
  'MANAGE_PMS_JOB_MASKING',
])

export function canonicalizeRolePermissionCode(value: string): string {
  const normalized = normalizeCode(value)
  return LEGACY_TO_CANONICAL[normalized] || normalized
}

export function isHiddenRolePermissionMatrixAlias(value: string): boolean {
  return HIDDEN_MATRIX_ALIASES.has(normalizeCode(value))
}

export function normalizeRolePermissionCode(value: string): string {
  return normalizeCode(value)
}
